import React from "react";
import PageBody from "Common/Custom/PageBody";
import AddItemBtn from "Common/Custom/AddItemBtn";
import { HeadingOne } from "Common/Custom/HeadingOne";
import CandidateShortlistListTable from "./components/CandidateShortlistListTable";

const CandidateShortlistList = () => {
    return (
        <PageBody
            card={true}
            headerchildren={
                <>
                    <HeadingOne>Candidate Shortlist</HeadingOne>
                    <AddItemBtn url="add-candidate-shortlist" title="Create" />
                </>
            }
        >
            {/* Table section */}
            <div className="col-12">
                <CandidateShortlistListTable />
            </div>
        </PageBody>
    );
};

export default CandidateShortlistList;
